<lx-price-lists-portal-more-info-list title="Tuition upgrades & add-ons" [moreInfoItems]="tuitionUpgradesAndAddOns"></lx-price-lists-portal-more-info-list>
<lx-price-lists-portal-more-info-list title="Private courses & online lessons" [moreInfoItems]="privateLessons"></lx-price-lists-portal-more-info-list>
<lx-price-lists-portal-more-info-list
  title="Study language + work experience/internship"
  [moreInfoItems]="workExperience"
></lx-price-lists-portal-more-info-list>
<lx-price-lists-portal-more-info-list title="Study language + volunteering" [moreInfoItems]="volunteering"></lx-price-lists-portal-more-info-list>
